export default "/_next/static/images/furniture-modal-ff5258a37a6e8622557ec433c7a0b998.png";